<template>
  <section>
    <HomeHeader />
    <HomeGrid />
    <HomeNewsletter />
    <HomeAbout />

    <footer class="navigation-footer">
      <p>{{ currentYear }} &copy; Centre Qigong Laflamme. {{ $t('common.legal') }}</p>

      <div class="navigation-footer__options">
        <RouterLink to="/" class="navigation-footer__lang -active">Français</RouterLink>
        <span>/</span>
        <RouterLink to="/en" class="navigation-footer__lang">English</RouterLink>
      </div>
    </footer>
  </section>
</template>

<script>
import HomeHeader from './partials/HomeHeader.vue'
import HomeGrid from './partials/HomeGrid.vue'
import HomeNewsletter from './partials/HomeNewsletter.vue'
import HomeAbout from './partials/HomeAbout.vue'

export default {
  name: 'Home',
  components: { HomeHeader, HomeGrid, HomeNewsletter, HomeAbout },
  props: {
    lang: { type: String, default: 'en' }
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      isModalVisible: false,
      model: {
        email: '',
        name: ''
      }
    }
  },
  methods: {
    onSubmit() {
      this.isModalVisible = true
    }
  }
}
</script>
